import {
  AggregateLiquidityData,
  StressLevel,
} from '../../fundAssetLiquidationTime/table';
import React, { ReactElement } from 'react';
import {
  buildMainData,
  createAgTableColumns,
  createAgTableColumnsPDF,
  csvAggregateLiquidation,
} from './ag-table.data';
import GridItem from '../../../../layout/GridComponents/GridItem';
import CustomTable from '../../../../tables/CustomTable';
import { liquidityMap } from '../AggregateLiquidationPage';
import { CustomColumn } from '../../../../../types/components/tables/tableTypes';

interface Props {
  selectedLevel: StressLevel;
  pageModelData: any;
  loading?: boolean;
}

function AggregateLiquidationTable(props: Props): ReactElement {
  const tableData = props.pageModelData
    ? buildMainData(props.pageModelData, props.selectedLevel)
    : [];
  const columns = createAgTableColumns(props.selectedLevel);
  const pdfColumns = createAgTableColumnsPDF(props.selectedLevel);

  return (
    <GridItem xs={12} card>
      <CustomTable<AggregateLiquidityData>
        data={tableData}
        csvFields={csvAggregateLiquidation}
        showToolbar
        toolbarComponents={{
          toolbarTitle: liquidityMap[props.selectedLevel],
        }}
        additionalDetailForPdf={`Stress Level: ${liquidityMap[props.selectedLevel]}`}
        columns={columns as unknown as CustomColumn<AggregateLiquidityData>[]}
        options={{
          paging: false,
          exportButton: true,
          pageSizeOptions: [5, 10, 20, tableData.length],
        }}
        loading={props.loading ?? false}
      // pdfColumns={pdfColumns}
      />
    </GridItem>
  );
}

export default AggregateLiquidationTable;
